import React, { useState } from 'react';
import { TabKeyIdentifierPrefix } from './Tab';

export enum TabPanelTheme {
    Blue = 'blue',
    Gray = 'gray',
    White = 'white',
    Red = 'red',
}

export const TabPanel: React.FC<{
    id: string;
    theme: TabPanelTheme;
    defaultIndex?: number;
    hint?: string;
    width?: string;
    children: any;
}> = ({ id, defaultIndex = 0, theme, hint, width = 'auto', children }) => {
    const [activeIndex, setActiveIndex] = useState(defaultIndex);

    const tabs = React.Children.map(children, (child) => {
        return child.key?.startsWith(TabKeyIdentifierPrefix) ? child : null;
    }).filter(Boolean);

    const setStyle = {
        width: width,
    };

    const inactiveStyle = (activeIndex: number, currentIndex: number) => {
        if (currentIndex === activeIndex - 1) {
            return 'inactiveLeft';
        } else if (currentIndex === activeIndex + 1) {
            return 'inactiveRight';
        } else {
            return 'inactive';
        }
    };

    return (
        <>
            <div
                id={id}
                className={`tabPanel ${theme}`}
                style={setStyle}
                title={hint}
            >
                <div
                    className='tabList'
                    role='tablist'
                >
                    {tabs &&
                        tabs.map((tab, index) => (
                            <button
                                key={index}
                                className={`tabButton ${theme} ${activeIndex === index ? 'active' : inactiveStyle(activeIndex, index)}`}
                                onClick={() => setActiveIndex(index)}
                                role='tab'
                                aria-selected={activeIndex === index}
                                aria-controls={`tab-panel-${index}`}
                                id={`tab-${index}`}
                            >
                                {tab.props.text}
                            </button>
                        ))}
                </div>
                <div className='tabContent'>
                    {tabs && tabs[activeIndex] && (
                        <div
                            id={`tab-panel-${activeIndex}`}
                            aria-labelledby={`tab-${activeIndex}`}
                        >
                            {tabs[activeIndex]}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};
